/* eslint-disable no-script-url */
import React, { useEffect, useState } from "react";
import Layout from "../Components/layout/Layout";
import BASE_URL from "../Components/auth/Baseurl";
import axios from "axios";
import { Link } from "react-router-dom";

const Squawks = () => {
  const [blog, setBlog] = useState([]);
  const [filterBlog, setFilterBlog] = useState([]);

  const blogData = async () => {
    const response = await axios.get(`${BASE_URL}/blog`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    setBlog(response.data.data);
    setFilterBlog(response.data.data);
  };

  useEffect(() => {
    // blogData();
  }, []);

  const [activeTab, setActiveTab] = useState("All");

  const articles = [
    {
      name: "The Most Fun Fly-Ins in America",
      url: "https://fly-inn.com/the-most-fun-fly-ins-in-america/",
      image: "https://fly-inn.com/wp-content/uploads/2023/11/oshkosh-camping-sh-1440x786-2211823237-1024x559.webp",
      created_by: "PIC",
      created_on: "November 26, 2023"
    },
    {
      name: "11 Most Popular Air Shows in the United States",
      image: "https://fly-inn.com/wp-content/uploads/2018/11/air_show_3240975_1140X760_blog.jpg",
      url: "https://fly-inn.com/11-most-popular-air-shows-in-the-united-states/",
      created_by: "PIC",
      created_on: "November 25, 2023"
    },
    {
      name: "4 of the Grooviest Airpark Communities in the USA!",
      image: "https://fly-inn.com/wp-content/uploads/2023/08/lakeway-airpark-lakeway-texas1620X1080-1140x760.webp",
      url: "https://fly-inn.com/4-of-the-grooviest-airpark-communities-in-the-usa/",
      created_by: "PIC",
      created_on: "December 29, 2021"
    },
    {
      name: "Innovative Ideas for a Hangar Home",
      image: "https://fly-inn.com/wp-content/uploads/2018/11/Aviation_community_1080X720.webp",
      url: "https://fly-inn.com/innovative-ideas-for-a-hangar-home/",
      created_by: "PIC",
      created_on: "November 19, 2018"
    },
    {
      name: "Ultimate Travel Packing List For Ladies",
      image: "https://fly-inn.com/wp-content/uploads/2018/10/suitcase_1080X720_612706646.webp",
      url: "https://fly-inn.com/ultimate-travel-packing-list-for-ladies/",
      created_by: "PIC",
      created_on: "October 18, 2018"
    },
    {
      name: "Ultimate Travel Packing List for Gentlemen",
      image: "https://fly-inn.com/wp-content/uploads/2018/10/male_traveler_1440x960_as_572607740-1140x760.webp",
      url: "https://fly-inn.com/ultimate-travel-packing-list-for-gentlemen/",
      created_by: "PIC",
      created_on: "October 18, 2018"
    },
    {
      name: "Ultimate Travel Packing List for Pilots",
      image: "https://fly-inn.com/wp-content/uploads/2018/10/pilot_bag_1440X960_as_295026316-1140x760.webp",
      url: "https://fly-inn.com/ultimate-travel-packing-list-for-private-pilots/",
      created_by: "PIC",
      created_on: "October 18, 2018"
    },
    {
      name: "Ultimate Travel Pack List for Parents of Young Children",
      image: "https://fly-inn.com/wp-content/uploads/2018/10/momnappies-AS-1080x720-397653111.webp",
      url: "https://fly-inn.com/ultimate-trave-pack-list-for-parents-of-young-children/",
      created_by: "PIC",
      created_on: "October 18, 2018"
    },
    {
      name: "Ultimate Travel Pack List for Pet Parents",
      image: "https://fly-inn.com/wp-content/uploads/2018/10/dog_at_airplane_color_adjusted-1140x760.webp",
      url: "https://fly-inn.com/ultimate-travel-pack-list-for-pet-parents/",
      created_by: "PIC",
      created_on: "October 18, 2018"
    },
    {
      name: "Ultimate Airplane Camping List",
      image: "https://fly-inn.com/wp-content/uploads/2018/10/airplane_camping_1080X540_425091518.webp",
      url: "https://fly-inn.com/ultimate-airplane-camping-list/",
      created_by: "PIC",
      created_on: "October 18, 2018"
    },
    {
      name: "Ultimate Pilot Flight Bag List",
      image: "https://fly-inn.com/wp-content/uploads/2018/10/female_pilot_lips_ear_1440x960_as_148769943-1140x760.webp",
      url: "https://fly-inn.com/ultimate-pilot-flight-bag-list/",
      created_by: "PIC",
      created_on: "October 18, 2018"
    }
  ];

  const handleTabClick = (tab) => {
    // product company stays policy community
    setActiveTab(tab);
    const filter = blog?.filter(
      (fil) => fil.news_by_topic === tab.toLowerCase()
    );
    if (tab === "All") {
      setFilterBlog(blog);
    } else {
      setFilterBlog(filter);
    }
  };

  // const [swiper, setSwiper] = useState(null);

  return (
    <Layout>
      <div className="bg-white">

        <div className="container px-4 mx-auto my-10 md:px-12">
          <h1 className="mt-10 text-3xl font-bold">
            Squawks
          </h1>
          <article
            id="post-531"
            className="post-531 page type-page status-publish hentry"
          >
            <div className="grid items-center justify-center grid-cols-1 gap-10 my-5 md:grid-cols-2">
              <div className="elementor-widget-container">
                <p>July 18, 2024</p>
                <div className="ab_text-title fl-wrap">
                  <h1 className="text-3xl font-bold">
                    4 Promises Fly-Inn.com Hosts Make: Because Pilots Deserve to Be Pampered, Too
                  </h1>
                  <a
                    href="https://fly-inn.com/4-promises-fly-inn-com-hosts-make-because-pilots-deserve-to-be-pampered-too/"
                    style={{ padding: "15px 44px 15px 16px" }}
                    className="btn float-btn color2-bg"
                    type="submit"
                  >
                    Read more
                    <i style={{ color: "#3B4249" }} className="fal fa-users" />
                  </a>
                </div>
              </div>
              <div className="elementor-widget-container">
                <img
                  style={{ borderRadius: "20px" }}
                  src="https://fly-inn.com/wp-content/uploads/2024/12/Untitled-design-2-1140x720.png"
                  alt=""
                />
              </div>
            </div>
            <div className="clearfix entry-content">
              <div
                data-elementor-type="wp-post"
                data-elementor-id={531}
                className="elementor elementor-531"
              >
                <hr />
                <div className="elementor-container elementor-column-gap-default">
                  <div
                    className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ed96de7"
                    data-id="ed96de7"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-35ead37 elementor-widget elementor-widget-section_title"
                        data-id="35ead37"
                        data-element_type="widget"
                        data-widget_type="section_title.default"
                      >
                        <div
                          style={{ paddingTop: "50px" }}
                          className="elementor-widget-container"
                        >
                          <div className=" section-title-dk-blue fl-wrap">
                            <h2
                              style={{
                                textAlign: "start",
                                marginBottom: "30px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "30px",
                                  fontWeight: "700",
                                }}
                              >
                                Latest news
                              </span>
                            </h2>{" "}
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-19d20d3 elementor-widget elementor-widget-members_grid"
                        data-id="19d20d3"
                        data-element_type="widget"
                        data-widget_type="members_grid.default"
                      >
                        <div className="elementor-widget-container">
                          <div
                            className="row"
                            style={{ display: "flex", flexWrap: "wrap" }}
                          >
                            {/* team-item */}
                            {blog?.map((blo, index) => {
                              const parser = new DOMParser();
                              const doc = parser.parseFromString(
                                blo?.description,
                                "text/html"
                              );
                              const imgSrc = doc.querySelector("img")?.src;
                              return (
                                <div key={index} className="col-md-3">
                                  <Link
                                    to={`/squawks/${blo?.id}`}
                                    state={{
                                      imgSrc: imgSrc,
                                      description: blo?.description,
                                      title: blo?.heading,
                                      subTitle: blo?.sub_heading,
                                      date: blo?.date,
                                    }}
                                  >
                                    <div className="team-photo">
                                      <img
                                        decoding="async"
                                        style={{
                                          width: "100%",
                                          height: "30vh",
                                          objectFit: "cover",
                                        }}
                                        className="respimg wp-post-image lazy loaded"
                                        alt=""
                                        src={
                                          imgSrc ||
                                          "https://townhub.cththemes.org/wp-content/uploads/2017/07/2.jpg"
                                        }
                                      />{" "}
                                    </div>
                                    <div className="team-info fl-wrap">
                                      <h3 className="section-title">
                                        {blo?.heading}
                                      </h3>{" "}
                                      <p>{blo?.date}</p>
                                    </div>
                                  </Link>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <h2 className="text-center">
                  <span className="text-2xl font-bold">
                    Follow Fly-inn for news and travel inspiration
                  </span>
                </h2>{" "} */}
                <div>
                  {/* <ul className="flex-wrap gap-4 custom-nav-tabs md:py-10">
                    {[
                      "All",
                      "Company",
                      "Stays",
                      "Product",
                      "Policy",
                      "Community",
                    ].map((tab) => (
                      <li className="custom-nav-item" key={tab}>
                        <Link
                          className={`custom-nav-link ${activeTab === tab ? "active" : ""
                            }`}
                          to="javascript:0"
                          onClick={() => handleTabClick(tab)}
                        >
                          {tab}
                        </Link>
                      </li>
                    ))}
                  </ul> */}
                  <div className="custom-tab-content">
                    <div className="custom-tab-pane active">
                      {filterBlog?.map((blo, index) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(
                          blo?.description,
                          "text/html"
                        );
                        const imgSrc = doc.querySelector("img")?.src;
                        return (
                          <>
                            <div
                              id="member-988"
                              className="cthiso-item team-box post-988 member type-member status-publish has-post-thumbnail hentry"
                            >
                              <Link
                                to={`/squawks/${blo?.id}`}
                                state={{
                                  imgSrc: imgSrc,
                                  description: blo?.description,
                                  title: blo?.heading,
                                  subTitle: blo?.sub_heading,
                                  date: blo?.date,
                                }}
                              >
                                <div className="team-photo">
                                  <img
                                    decoding="async"
                                    style={{
                                      width: "100%",
                                      height: "40vh",
                                      objectFit: "cover",
                                    }}
                                    className="respimg wp-post-image lazy loaded"
                                    alt=""
                                    src={
                                      imgSrc
                                        ? imgSrc
                                        : "https://townhub.cththemes.org/wp-content/uploads/2017/07/2.jpg"
                                    }
                                  />{" "}
                                </div>
                                <div className="team-info fl-wrap">
                                  <h3 className="section-title">
                                    {blo?.heading}
                                  </h3>{" "}
                                  <p>{blo?.date}</p>
                                </div>
                              </Link>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  </div>
                </div>


                {/* {articles} */}
                <div className="grid items-center justify-center grid-cols-1 gap-10 my-5">
                  {articles.map((article, index) => (
                    <div
                      key={index}
                      className="flex-col gap-6 md:flex md:flex-row md:gap-10 elementor-widget-container"
                    >
                      {/* Image Section */}
                      <img
                        className="object-cover w-full h-auto md:w-80"
                        style={{ borderRadius: "20px" }}
                        src={article.image} // Use the article's image URL
                        alt={article.name} // Use the article's name as alt text
                      />

                      {/* Content Section */}
                      <div className="flex flex-col justify-center ab_text-title fl-wrap">
                        <h1
                          className="text-2xl font-bold md:text-3xl lg:text-4xl"
                          style={{
                            fontSize: "clamp(24px, 5vw, 36px)", // Responsive font size
                          }}
                        >
                          {article.name} {/* Display the article's name */}
                        </h1>
                        <p
                          className="mt-2 mb-4 text-lg md:text-xl lg:text-2xl"
                          style={{
                            fontSize: "clamp(16px, 3vw, 22px)", // Responsive font size
                          }}
                        >
                          Created by {article.created_by} on {article.created_on}{" "}
                          {/* Display author and date */}
                        </p>
                        <a
                          href={article.url} // Link to the article's URL
                          className="inline-block px-6 py-3 text-sm btn float-btn color2-bg w-fit md:text-base lg:text-lg"
                          type="submit"
                        >
                          Read more
                          <i
                            style={{ color: "#3B4249" }}
                            className="ml-2 fal fa-users"
                          />
                        </a>
                      </div>
                    </div>
                  ))}
                </div>


              </div>
            </div>
          </article>
        </div>
      </div>
    </Layout>
  );
};

export default Squawks;
// https://jskim1991.medium.com/react-swiper-with-pagination-sample-4177f411c70d
